<div class="login-inside-container" id="div_login-inside-container_26fa54c0">
  <h1 aria-label="Link has expired" title="Link has expired" id="h1_9686284e">
    Link has expired.
  </h1>
  <form [formGroup]="frmLink" id="form_a4e9d0d6">
    <label id="label_af2395f7"
      >Please enter your email address, and we’ll send a new link to set up your
      account.</label
    >
    <span class="p-float-label" id="span_p-float-label_2ac8224f">
      <input
        id="email"
        type="email"
        pInputText=""
        name="email"
        formControlName="email"
      />
      <label for="email" id="label_1722c481">Email</label>
    </span>
    <small
      class="p-error block"
      *ngIf="frmLink.controls['email'].hasError('pattern')"
      id="small_p-error_54ce5224"
      >Please enter a valid email address.</small
    >
    <div class="btn-panel" id="div_btn-panel_656cd600">
      <button
        class="next-button"
        (click)="resendLink()"
        [disabled]="!frmLink.controls['email'].valid"
        id="button_next-button_f22914b7"
      >
        RESEND
      </button>
    </div>
  </form>
</div>

<p-toast
  position="top-center"
  life="500000"
  key="toast"
  id="p-toast_4cd7b104"
></p-toast>
